import * as React from "react";

const PageFooter: React.FC = () => {
	const privacyUrl = process.env.REACT_APP_PRIVACY_URL;

	return (
		<footer className="container no-print">
			<div className="row justify-content-md-center">
				{privacyUrl && (
					<a className="col-md-auto" href={privacyUrl} target="_blank">
						Privacy Policy
					</a>
				)}
			</div>
		</footer>
	);
};

export default PageFooter;
